import React, { useState, memo } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { likeComment, unlikeComment } from "../../redux/comment/commentAction";
import { motion } from "framer-motion";
import { CommentLoaders } from "../SkeletonLoaders";
import { formatTime } from "../../helper";
import { LuDot } from "react-icons/lu";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import defaultAvatar from "../../assests/defaultImage.png";
import { IoMdRefresh } from "react-icons/io";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import LinkifiedText from "../LinkifiedText";



export const ReplyItems = memo(({ reply, retryReply, myId }) => {
    const { user, createdAt, text, status, commentId, replyId } = reply;
    const { firstName, lastName, profilePhoto, 
        // userId 
    } = user;
    const profileImage = profilePhoto && profilePhoto.length > 0 ? profilePhoto[0]?.photoPublicUrl : '';

    return (
        <motion.div layout className="">
            {" "}
            {/* Adjust margin to position the reply below the comment */}
            <div className="text-sm font-outfit items-center">
                <div className="flex gap-2 items-center">
                    <Link to="/profile">
                        <img
                            src={profileImage || defaultAvatar}
                            alt="Profile"
                            className="w-8 h-8 rounded-full bg-customDark"
                        />
                    </Link>

                    <div className="flex items-center gap-10 justify-between">
                        <p className="font-bold">
                            {firstName} {lastName}
                        </p>
                    </div>
                    {!createdAt && (
                        <p
                            className={`ml-2 ${status === "failed" ? "text-red-600" : "text-gray-500"
                                }`}
                        >
                            {status === "pending" ? "posting..." : status}
                        </p>
                    )}
                    {!createdAt && status === "failed" && (
                        <IoMdRefresh
                            onClick={() => retryReply({ commentId, replyId, comment: text })}
                            className="hover:text-white text-gray-500 text-sm cursor-pointer hover:scale-105 duration-300 transition-all"
                        />
                    )}
                </div>

                <div className="ml-8 mt-1">
                    <div className="flex flex-col justify-between">
                        <p className="bg-customDark p-2 w-fit rounded-lg rounded-tl-none inline-block break-words">
                            <LinkifiedText text={text} />
                        </p>
                    </div>
                </div>
            </div>
        </motion.div>
    );
});

export const CommentItem = memo(
    ({
        comment,
        reply,
        replies,
        loadReplies,
        myId,
        retryReply,
        retryComment,
        handleDelete,
        isEditing
    }) => {
        const dispatch = useDispatch();
        const { commentId, status, createdAt, liked, text, user, replyCount } =
            comment ?? {};
        const { firstName, lastName, profilePhoto, userId } = user ?? {};
        const profileImage =
            profilePhoto?.length > 0 ? profilePhoto[0]?.photoPublicUrl : "";
        const [likeStatus, setLikeStatus] = useState(liked);
        const [showReplies, setShowReplies] = useState({
            value: false,
            loaded: false,
            hidden: false,
        });
        const [repliesLoading, setRepliesLoading] = useState(false);
        const [isDeleting, setIsDeleting] = useState(false);

        const isMine = myId === userId;

        // useEffect(() => {
        //     if (replies.length !== repliesLengthRef.current && showReplies.hidden) {
        //         setShowReplies(prev => ({ ...prev, hidden: false }))
        //         repliesLengthRef.current = replies.length
        //     }
        // }, [replies.length, showReplies.hidden])

        const fetchReplies = async () => {
            try {
                if (showReplies.value) {
                    return setShowReplies((prev) => ({
                        ...prev,
                        value: false,
                        hidden: true,
                    }));
                } else if (!showReplies.value && !showReplies.loaded) {
                    setShowReplies((prev) => ({ ...prev, value: true }));
                    setRepliesLoading(true);
                    await loadReplies(commentId);
                    setShowReplies({ value: true, loaded: true });
                    setRepliesLoading(false);
                } else {
                    setShowReplies((prev) => ({ ...prev, value: true, hidden: false }));
                }
            } catch (error) {
                setShowReplies((prev) => ({ ...prev, value: false }));
                setRepliesLoading(false);
                toast.error(error.message);
            }
        };

        const handleLikeComment = () => {
            dispatch(likeStatus ? unlikeComment(commentId) : likeComment(commentId));
            setLikeStatus((prev) => !prev);
        };

        return (
            <motion.div
                layout={"preserve-aspect"}
                initial={
                    commentId?.startsWith("fake-comment")
                        ? { opacity: 0, y: 10 }
                        : undefined
                }
                animate={
                    commentId?.startsWith("fake-comment")
                        ? { opacity: 1, y: 0 }
                        : undefined
                }
                className={`flex flex-col w-full ${isEditing ? 'opacity-50 pointer-events-none' : ''}`}
            // onClick={() => retryComment({ commentId, comment: text })}
            >
                <div
                    className={`text-sm font-outfit items-center ${isDeleting ? "pointer-events-none opacity-65" : ""
                        }`}
                >
                    <div className={`text-sm font-outfit items-center ${isDeleting ? "pointer-events-none opacity-65" : ''}`}>
                        <div className="flex gap-2 items-center">
                            <Link to={myId === userId ? '/profile' : `/user/${userId}`}>
                                <img src={profileImage || defaultAvatar} alt="Profile" className="w-10 h-10 rounded-full bg-customDark" />
                            </Link>
                            <Link to={myId === userId ? '/profile' : `/user/${userId}`}>
                                <div className="flex items-center gap-10 justify-between">
                                    <p className="font-bold">{firstName} {lastName}</p>
                                </div>
                            </Link>
                            {!createdAt && <p className={`ml-2 ${status === 'failed' ? 'text-red-600' : 'text-gray-500'}`}>{status === 'pending' ? "posting..." : status}</p>}
                            {!createdAt && status === "failed" &&
                                <IoMdRefresh
                                    onClick={() => retryComment({ commentId, comment: text })}
                                    className="hover:text-white text-gray-500 text-lg cursor-pointer hover:scale-105 duration-300 transition-all"
                                />
                            }
                        </div>

                        <div className="ml-10 mt-1">
                            <div className="flex flex-col justify-between">
                                <p className="bg-customDark p-2 w-fit rounded-lg rounded-tl-none inline-block break-words">
                                    <LinkifiedText text={text} />
                                </p>
                                {createdAt && (
                                    <div className="flex items-center gap-3 mt-2">
                                        <button
                                            onClick={handleLikeComment}
                                            className={`text-gray-500 hover:text-white ${likeStatus ? "text-yellow-500" : ""
                                                }`}
                                        >
                                            {likeStatus ? "Liked" : "Like"}
                                        </button>
                                        <button
                                            onClick={() => reply({ user, commentId })}
                                            className="text-gray-500 hover:text-white"
                                        >
                                            Reply
                                        </button>

                                        {isMine && (
                                            <button
                                                onClick={async () => {
                                                    try {
                                                        setIsDeleting(true);
                                                        await handleDelete(commentId);
                                                    } catch (error) {
                                                        setIsDeleting(false);
                                                    }
                                                }}
                                                className="text-red-400 hover:text-red-700"
                                            >
                                                {isDeleting ? "Deleting..." : "Delete"}
                                            </button>
                                        )}

                                        {(() => {
                                            const isEditable = isMine && createdAt && moment(createdAt).add(3, 'minutes').isAfter(moment());
                                            return isEditable ? (
                                                <button
                                                    onClick={() => reply({ commentId, user, comment: text, isEdit: true })}
                                                    className="text-gray-500 hover:text-white"
                                                >
                                                    Edit
                                                </button>
                                            ) : null;
                                        })()}

                                        <p className="text-white flex items-center">
                                            {" "}
                                            <LuDot /> {formatTime(createdAt)}
                                        </p>

                                        {replyCount > 0 && (
                                            <button
                                                disabled={repliesLoading}
                                                onClick={fetchReplies}
                                                className="flex items-center gap-[2px] hover:text-white text-gray-500"
                                            >
                                                {showReplies.value && !repliesLoading ? (
                                                    <FaAngleUp className="text-white" />
                                                ) : (
                                                    <FaAngleDown className="text-white" />
                                                )}{" "}
                                                {showReplies.value && !repliesLoading
                                                    ? "Hide replies"
                                                    : "View replies"}
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col items-start justify-start gap-2 ml-10 mt-2">
                        {replies.length > 0 &&
                            !showReplies.hidden &&
                            replies.map((reply) => (
                                <ReplyItems
                                    key={reply.replyId}
                                    reply={reply}
                                    retryReply={retryReply}
                                />
                            ))}
                        {repliesLoading && <CommentLoaders />}
                    </div>
                </div>
            </motion.div>
        );
    }
);

const CommentModal = ({ postUrl, onClose, postId, createdAt, comments }) => {
    return (
        <div
            className={`${postUrl?.length > 0 ? "w-1/2" : "w-full"
                } p-4 flex flex-col justify-between h-full relative`}
        >

        </div>
    );
};

export default CommentModal;
